import React from 'react';
import SchoolInformationSection from '@/components/SchoolInformation/SchoolInformation';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';

const breadcrumbItems = [
        { title: "Home", path: "/" },
        { title: "School Information", path: "/schoolinfo" },
    ];

const SchoolInformation = () => {

    return (
        <>
        <div className="schoolinfopage-container">
            <div className="schoolinfopage-inner-container">
            <Breadcrumb items={breadcrumbItems} />
            <SchoolInformationSection
                header="School Information"
                description= {
                    <>
                    <b>You'll be able to access your K12 School (OLS) on your first day of school. </b> <br /> <br/>
                    In the meantime, get important information on what to expect before school starts.
                    </>
                }
                faqCtaUrl="/schoolinfo/school-start-faqs"
                theme="transparent" 
            />
            </div>
        </div>
        </>
    );
};

export default SchoolInformation;